import React from 'react';
import './Banner.css';

const Banner = ({ title, breadcrumbs }) => {
  return (
    <div className="banner">
      <div className="banner-content">
        <h1>{title}</h1>
        <nav className="breadcrumb">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span className="separator"> / </span>}
              <a href={crumb.link}>{crumb.text}</a>
            </React.Fragment>
          ))}
        </nav>
      </div>
      <div className="banner-decorations">
        <div className="jumping-kid"></div>
        <div className="bicycle-kid"></div>
        <div className="bee"></div>
        <div className="tricycle-kid"></div>
      </div>
    </div>
  );
};

export default Banner;